import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import api from "../../globals/axios";
import { useAlert } from "../../components/Alert";
import LoaderContainer from "../../components/LoaderContainer";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GenericButton from "../../components/Custom/GenericButton";
import {
  CustomLabel,
  CustomTitle,
} from "../../components/Custom/CustomTypography";
import { useLocation } from "react-router-dom";

export default function AddProgramTaskForm() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { programId } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    start_date: "",
    due_date: "",
    description: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const { showAlert } = useAlert();

  const location = useLocation();
  const { program_type, program_id } = location.state || {};

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [taskType, setTaskType] = useState(
    program_type === "HYBRID" ? "VERIFIABLE" : program_type || "VERIFIABLE"
  );

  const handleTaskTypeChange = (event) => {
    setTaskType(event.target.value);
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const response = await api.post(
        "/programs/programtasks/?program_type=DECAR",
        {
          ...formData,
          program_input: programId,
          task_type: taskType,
        }
      );
      if (response && response.data) {
        showAlert("success", "Task added successfully!");
        navigate(`/program/${program_id}`);
      }
    } catch (error) {
      showAlert("error", "Error adding the task.");
      console.error("Task creation error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (program_type && program_type !== "HYBRID") {
      setTaskType(program_type);
    }
  }, [program_type]);

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={submitting}>
        <Container maxWidth="xs">
          <CustomTitle>{t("Add Task")}</CustomTitle>
          <Box mt={2}>
            <CustomLabel>{t("Enter Task Name")}</CustomLabel>
            <Box mt={2}>
              <TextField
                label={t("Task Name")}
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                required
              />
            </Box>
          </Box>

          <Box mt={2}>
            <FormControl component="fieldset">
              <FormLabel component="legend">{t("Task Type")}</FormLabel>
              <RadioGroup
                row
                name="task-type"
                value={taskType}
                onChange={handleTaskTypeChange}
              >
                <FormControlLabel
                  value="VERIFIABLE"
                  control={<Radio />}
                  label={t("Verifiable")}
                  disabled={program_type !== "HYBRID"}
                />
                <FormControlLabel
                  value="VOLUNTARY"
                  control={<Radio />}
                  label={t("Voluntary")}
                  disabled={program_type !== "HYBRID"}
                />
              </RadioGroup>
            </FormControl>
          </Box>

          <Box mt={2}>
            <CustomLabel>{t("Add Descriptions")}</CustomLabel>
            <Box mt={2}>
              <TextField
                label={t("Description")}
                name="description"
                value={formData.description}
                onChange={handleChange}
                fullWidth
                multiline
                rows={6}
              />
            </Box>
          </Box>

          <Box mt={2}>
            <CustomLabel>{t("Enter start date")}</CustomLabel>
            <Box mt={2}>
              <TextField
                label={t("Start Date")}
                name="start_date"
                value={formData.start_date}
                onChange={handleChange}
                fullWidth
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </Box>
          </Box>
          <Box mt={2}>
            <CustomLabel>{t("Enter end date")}</CustomLabel>
            <Box mt={2}>
              <TextField
                label={t("Due Date")}
                name="due_date"
                value={formData.due_date}
                onChange={handleChange}
                fullWidth
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            </Box>
          </Box>

          <Box mt={2}>
            <GenericButton
              onClick={handleSubmit}
              disabled={submitting}
              padding="10px 0"
              fontSize="14px"
              hideIcon
              backgroundColor="#4CAF50"
              fontColor="white"
            >
              {submitting ? t("Submitting...") : t("Add Task")}
            </GenericButton>
          </Box>
        </Container>
      </LoaderContainer>
    </>
  );
}
